<template>
  <li
    :id="'search-item-' + index"
    role="option"
    tabIndex="-1"
    :aria-selected="ariaSelected"
    :class="activeClass"
  >
    <a
      :ref="(el) => linkRef = el"
      :href="'/member-resources/' + hit.slug"
      @focus="$emit('tab-focused', index)"
    >
      <ais-highlight
        attribute="title"
        :hit="hit"
      />
    </a>
  </li>
</template>

<script>
/* Components */
import { AisHighlight } from 'vue-instantsearch/vue3/es';

export default {
  components: {
    AisHighlight,
  },

  props: {
    hit: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },

    selectedIndex: {
      type: Number,
      required: true,
    },

    isBtnFocused: {
      type: Boolean,
      required: true,
    },
  },

  emits: {
    'tab-focused': null,
  },

  data() {
    return {
      linkRef: null,
    };
  },

  computed: {
    /**
     * Set the list element's `class` attribute.
     * 
     * @return string - Classes to be applied to the list item.
     */
    activeClass() {
      return this.isSelected ? 'active z-10' : '';
    },

    /**
     * Set the list element's `aria-selected` attribute.
     * 
     * @return string - True or false string (not a boolean) intended for the element attribute value.
     */
    ariaSelected() {
      return this.isSelected ? 'true' : 'false';
    },

    /**
     * Check the sub-component list element's index with the main component's `selectedIndex`.
     * 
     * @return bool - Boolean representing if the current list element is selected.
     */
    isSelected() {
      return this.index === this.selectedIndex;
    },
  },

  mounted() {
    window.addEventListener('keydown', this.handleKeyboardEvents);
  },

  unmounted() {
    window.removeEventListener('keydown', this.handleKeyboardEvents);
  },

  methods: {
    /**
     * Handle 'Enter' button click event.
     * Open selected/focused result items, ignore clear and cancel buttons.
     * 
     * @param  event e - Keyboard $event
     * @return void
     */
    handleKeyboardEvents(e) {
      /* Bail early if clear or cancel buttons are focused so they can be handled normally. */
      if (this.isBtnFocused) {
        return;
      }

      /* Clicking enter when an item is selected will trigger that link to open. */
      if (e.key === 'Enter' && this.isSelected) {
        e.preventDefault();
        this.linkRef.click();
      }

      return;
    },
  },
};
</script>
